<a class="nav-link" [routerLink]="tab.path" [routerLinkActive]="['router-link-active']" [class.active]="tab.active" [queryParams]="tab.params" [hidden]="!tab.isShow">
  {{tab.title}}
</a>
